import Vue from 'vue'
import Vuelidate from 'vuelidate'
import App from './App.vue'
import router from './router'
import store from './store'
import jquery from 'jquery'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'
import vueCountryRegionSelect from 'vue-country-region-select'
import ElementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en'
Vue.config.productionTip = false;

Vue.use(VueTelInput)
Vue.use(ElementUi, { locale })
Vue.use(Vuelidate)
Vue.use(vueCountryRegionSelect)

new Vue({
  router,
  Vuelidate,
  store,
  render: h => h(App)
}).$mount('#app')
